export const _isBrowser = typeof document !== 'undefined';
export const _metaKey = '$$rcij';
export const _styleAttributeName = 'data-rcij';
